export const NEW_LINE_KEY_NAME = 'Enter';
export const BLUR_KEY_NAME = 'Escape';
export const EMPTY_ITEM = '';
export const MIN_INPUT_ID = 0;
